import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../app/stores/store";
import InfoParagraph from "../../components/infoParagraph/InfoParagraph";
import { HeadingEnum } from "../../enums/htmlTags";
import { setShowInterestCalculation, setShowInterestCalculator } from "../../pages/activeLoans/activeLoansSlice";

const InterestCalculation = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const goToInterestCalculator = useCallback(() => {
    dispatch(setShowInterestCalculator({ showInterestCalculator: true }));
    dispatch(setShowInterestCalculation({ showInterestCalculation: false }));
  }, [dispatch]);

  return (
    <InfoParagraph
      title={{
        titleName: t("loans.active.interestCalculation.info.title"),
        fontBold: true,
        titleType: HeadingEnum.h3,
      }}
      body={[
        { bodyText: t("loans.active.interestCalculation.info.body.p1") },
        {
          bodyText: (
            <div className="row py-3">
              <div className="col-auto d-sm-flex px-4">
                <button type="button" className="alt-btn alt-btn-ikon-beregn" onClick={goToInterestCalculator}>
                  {t("loans.active.interestCalculation.info.body.linkTitle")}
                </button>
              </div>
            </div>
          ),
        },
      ]}
    />
  );
};
export default InterestCalculation;
